import { createAsyncThunk } from '@reduxjs/toolkit';
import selectCurrentAccountId from '~/store/accountInfo/selectors/selectCurrentAccountId';
import { selectApiBaseUrl, selectAuthToken } from '~/store/env';

export default createAsyncThunk('accountInfo/getAccountUsers', async ({ query }, { getState }) => {
  if (query) {
    const apiBaseUrl = selectApiBaseUrl(getState());
    const accountId = selectCurrentAccountId(getState());
    const authToken = selectAuthToken(getState());
    // when no query is passed a max of 20 results are returned
    const url = new URL('/search/account-users', apiBaseUrl);
    url.searchParams.set('q', `(user.name=="*${query.toString().replace(/ /g, '*')}*")`);
    url.searchParams.set('accountId', accountId);
    url.searchParams.set('sort', 'id,desc');

    const params = {
      method: 'GET',
      headers: {
        authorization: authToken,
        'Content-Type': 'application/json',
        'X-API-VERSION': '2.0',
      },
    };
    const response = await fetch(url.toString(), params);

    if (!response.ok) {
      throw await response.text();
    }

    const data = await response.json();

    const userOptions = data?.content;

    return userOptions;
  }
  return undefined;
});
